import { FullCalendar } from 'vue-full-calendar'
import 'fullcalendar/dist/fullcalendar.css'
import interactionPlugin from '@fullcalendar/interaction'
import api from '../../services/service_calendar'
import Swal from 'sweetalert2'
import AlertPostponse from '../../components/alert_postponse'
import AlertSuccess from '../../components/alert_success'
import AlertDetail from '../../components/alert_detail'
var moment = require('moment')

export default {
  components: {
    FullCalendar,
    AlertPostponse,
    AlertSuccess,
    AlertDetail
  },
  data () {
    return {
      date_select: '',
      modal_day: [],
      now_month: '',
      view_mode: 0,
      currentPage: 1,
      items_perpage: 10,
      data_modal: {
        'id': 0,
        'title': '',
        'start': moment(new Date(), 'DD/MM/YYYY HH:mm'),
        'color': 'White',
        'all_day': false
      },
      result_data_now: [],
      events: [],
      config: {
        defaultView: 'month',
        locale: 'th',
        selectable: false,
        plugins: [interactionPlugin],
        header: {
          right: ''
        }
      }
    }
  },
  computed: {
    paginate: function () {
      // console.log(this.transfer_data)
      this.totalItem = this.result_data_now.length
      if (this.currentPage >= this.totalPages) {
        this.currentPage = Math.max(0, this.totalPages - 1)
      }
      var index = (this.currentPage - 1) * this.items_perpage
      return this.result_data_now.slice(index, index + this.items_perpage)
    }
  },
  methods: {
    getEventMonth (view) {
      this.$store.commit('Loading')
      this.now_month = this.convertTitleCalendar(view.title).split('-')
      this.getData()
    },
    itemRender (current, type, originalElement) {
      if (type === 'prev') {
        return 'Previous'
      } else if (type === 'next') {
        return 'Next'
      }
      return originalElement
    },
    onChange (pageNumber) {
      this.currentPage = pageNumber
    },
    getCardData () {
      this.$store.commit('Loading')
      let obj = {
        get_year: parseInt(this.now_month[1]),
        get_month: parseInt(this.now_month[0]),
        get_day: 0
      }
      api.list(
        this.REST_URL,
        {
          headers: {
            'Access-Token': sessionStorage.token
          }
        },
        obj,
        result => {
          if (result.response === 'success') {
            this.result_data_now = []
            for (let datas of result.data) {
              if (new Date(moment(datas.start).format('YYYY-MM-DD')).getTime() === new Date(moment(new Date()).format('YYYY-MM-DD')).getTime()) {
                this.result_data_now.push(datas)
                this.result_data_now['activityDate'] = moment(datas.start).format('DD/MM/YYYY HH:mm:ss')
              }
            }
            this.config = {
              defaultView: 'month',
              locale: 'th',
              selectable: false,
              plugins: [interactionPlugin],
              header: {
                right: ''
              }
            }
            this.events = result.data
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลปฎิทิน',
              description:
                result.message
            })
          }
          this.$store.commit('Loading')
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
          this.$store.commit('Loading')
        }
      )
    },
    getData () {
      let obj = {
        get_year: parseInt(this.now_month[1]),
        get_month: parseInt(this.now_month[0]),
        get_day: 0
      }
      api.list(
        this.REST_URL,
        {
          headers: {
            'Access-Token': sessionStorage.token
          }
        },
        obj,
        result => {
          if (result.response === 'success') {
            this.result_data_now = []
            for (let datas of result.data) {
              if (new Date(moment(datas.start).format('YYYY-MM-DD')).getTime() === new Date(moment(new Date()).format('YYYY-MM-DD')).getTime()) {
                datas['activityDate'] = moment(datas.start).format('DD/MM/YYYY HH:mm:ss')
                this.result_data_now.push(datas)
              }
            }
            this.config = {
              defaultView: 'month',
              locale: 'th',
              selectable: false,
              plugins: [interactionPlugin],
              header: {
                right: ''
              }
            }
            console.log(this.result_data_now)
            this.events = result.data
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลปฎิทิน',
              description:
                result.message
            })
          }
          this.$store.commit('Loading')
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
          this.$store.commit('Loading')
        }
      )
    },
    addData () {
      if (this.data_modal.title !== '') {
        $('#calendarForm').modal('hide')
        this.$store.commit('Loading')
        const obj = {
          'id': this.data_modal.id,
          'title': this.data_modal.title,
          'start': moment(this.data_modal.start).format('YYYY-MM-DD HH:mm:ss'),
          'color': this.data_modal.color,
          'all_day': false
        }
        if (obj.id === 0) {
          obj.status = 0
        } else {
          obj.status = 1
        }
        this.data_modal = {
          'id': 0,
          'title': '',
          'start': moment(new Date(), 'DD/MM/YYYY HH:mm'),
          'color': 'White',
          'all_day': false
        }
        api.new(
          this.REST_URL,
          {
            headers: {
              'Access-Token': sessionStorage.token
            }
          },
          obj,
          result => {
            if (result.response === 'success') {
              this.getData()
              this.$notification['success']({
                message: 'ข้อมูลการนัดหมาย',
                description:
                  'จัดการข้อมูลการนัดหมายสำเร็จ!!'
              })
            } else {
              this.$notification['warning']({
                message: 'จัดการข้อมูลปฎิทิน',
                description:
                  result.message
              })
            }
          },
          error => {
            console.log(obj.id)
            alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
            this.$store.commit('Loading')
          }
        )
      } else {
        this.data_modal = {
          'id': 0,
          'title': '',
          'start': moment(new Date(), 'DD/MM/YYYY HH:mm'),
          'color': 'White',
          'all_day': false
        }
        this.$notification['warning']({
          message: 'เพิ่มข้อมูลปฎิทิน',
          description:
            'ไม่มีข้อมูล'
        })
        $('#calendarForm').modal('hide')
      }
    },
    editModal (event) {
      event.start = moment(event.start, 'DD/MM/YYYY HH:mm')
      this.data_modal = event
      $('#calendarForm').modal('show')
    },
    AllDay (event) {
      this.$store.commit('Loading')
      this.date_select = this.dateFormatDMY(event)
      const d = this.date_select.split('/')
      let obj = {
        get_year: parseInt(d[2]),
        get_month: parseInt(d[1]),
        get_day: parseInt(d[0])
      }
      api.list(
        this.REST_URL,
        {
          headers: {
            'Access-Token': sessionStorage.token
          }
        },
        obj,
        result => {
          if (result.response === 'success') {
            this.modal_day = result.data
            if (this.modal_day.length > 0) {
              $('#calendarAllDay').modal('show')
            }
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลปฎิทิน',
              description:
                result.message
            })
          }
          this.$store.commit('Loading')
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
          this.$store.commit('Loading')
        }
      )
    },
    dateFormatDMYHM (date) {
      return moment(date).format('DD/MM/YYYY HH:mm')
    },
    delData (data) {
      Swal.fire({
        title: 'ลบข้อมูลการนัดหมาย',
        text: 'ท่านต้องการลบข้อมูลการนัดหมายนี้ใช่หรือไม่ ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes'
      }).then((result) => {
        if (result.value) {
          this.$store.commit('Loading')
          $('#calendarAllDay').modal('hide')
          const obj = {
            'id': data.id,
            'title': data.title,
            'start': moment(data.start).format('YYYY-MM-DD HH:mm:ss'),
            'color': data.color,
            'all_day': false,
            statue: 2
          }
          api.new(
            this.REST_URL,
            {
              headers: {
                'Access-Token': sessionStorage.token
              }
            },
            obj,
            result => {
              if (result.response === 'success') {
                this.getData()
                this.$notification['success']({
                  message: 'ลบการนัดหมาย',
                  description:
                    'ลบข้อมูลการนัดหมายสำเร็จ!!'
                })
              } else {
                this.$notification['warning']({
                  message: 'ลบข้อมูลปฎิทิน',
                  description:
                    result.message
                })
              }
            },
            error => {
              console.log(obj.id)
              alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
              this.$store.commit('Loading')
            }
          )
        }
      })
    },
    dropUpdate (event) {
      event.start = moment(event.start, 'DD/MM/YYYY HH:mm')
      this.data_modal = event
      this.addData()
    },
    cancelData (val) {
      console.log(val)
      Swal.fire({
        title: 'ลบข้อมูลการนัดหมาย',
        text: 'ท่านต้องการลบข้อมูลการนัดหมายนี้ใช่หรือไม่ ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes'
      }).then((result) => {
        if (result.value) {
          this.$store.commit('Loading')
          // $('#calendarAllDay').modal('hide')
          const obj = {
            'id': val.id,
            'company_id': 1,
            'branch_id': 1
          }
          api.cancelCalendar(
            this.REST_URL,
            {
              headers: {
                'Access-Token': sessionStorage.token
              }
            },
            obj,
            result => {
              this.$store.commit('Loading')
              if (result.response === 'success') {
                Swal.fire({
                  icon: 'success',
                  title: result.message,
                  showConfirmButton: false,
                  timer: 2500
                }).then(() => {
                  location.reload()
                })
              } else {
                this.$notification['warning']({
                  message: 'ลบข้อมูลปฎิทิน',
                  description:
                    result.message
                })
              }
            },
            error => {
              alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
              this.$store.commit('Loading')
            }
          )
        }
      })
    },
    changeActivity (data) {
      this.$store.state.activity_detail = data
    },
    confirmActivity (data) {
      this.$store.state.activity_detail = data
    },
    detailActivity (data) {
      this.$store.state.activity_detail = data
    }
  },
  mounted () {
    this.checkUser()
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/calendar.js